import Vue from "vue";

/**
 * Class Whatsapp Service
 */
export default class WhatsappService extends Vue {
  private customActions = {
    sendWhatsapp: { method: "POST", url: "integration/whatsapp/send-notification" }
  };
  private resource: any = this.$resource(
    "integration/whatsapp",
    {},
    this.customActions
  );

  public async sendWhatsapp(contact: any) {
    return await this.resource.sendWhatsapp({}, contact);
  }
}
